import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  hide: boolean
  isExport?: boolean
}

export const VideoTutorialWrap: React.FC<Props> = ({
  hide,
  isExport,
  children,
}) => {
  const cn = clsJoin(
    css.video_tutorial_wrap,
    isExport && css.export,
    hide && css.hide
  )

  return <div className={cn}>{children}</div>
}
